const inFlight = new Map<string, Promise<Response>>();

// Sibling components independently issue byte-identical GETs on mount. Sharing the
// in-flight promise collapses them into one network request. Entries are dropped as
// soon as the request settles, so nothing is ever served from a stale cache.
export const dedupedFetch: typeof fetch = (input, init) => {
  const method = (init?.method ?? 'GET').toUpperCase();
  if (method !== 'GET') return fetch(input, init);

  const url = typeof input === 'string' ? input : input.toString();
  const auth = (init?.headers as Record<string, string>)?.Authorization ?? '';
  const key = `${url}|${auth}`;

  const existing = inFlight.get(key);
  if (existing) return existing.then(response => response.clone());

  const request = fetch(input, init).finally(() => inFlight.delete(key));
  inFlight.set(key, request);

  return request.then(response => response.clone());
};
